import { ArrowLeft, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Footer from '../components/Footer';
import { useSafeBack } from '../hooks/useSafeBack';

const TermsAndConditions = () => {
  const navigate = useNavigate();
  const { goBack } = useSafeBack('/');

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1">
        <div className="mx-auto max-w-3xl px-4 py-8">
          {/* Back Button + Home */}
          <div className="flex items-center gap-2 mb-6">
            <Button
              variant="ghost"
              onClick={goBack}
              className="h-10 px-0 text-sm font-medium text-zinc-500 hover:text-zinc-900 hover:bg-transparent"
              data-testid="back-btn"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate('/dashboard')}
              className="h-8 w-8"
              data-testid="nav-home-btn"
              aria-label="Home"
            >
              <Home className="w-4 h-4 text-zinc-400" />
            </Button>
          </div>

          {/* Header */}
          <h1 className="text-3xl font-bold text-zinc-900 mb-8">Terms and Conditions</h1>

          {/* Content */}
          <div className="prose prose-zinc max-w-none">
            {/* Acceptance of Terms */}
            <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">Acceptance of Terms</h2>
            <p className="text-zinc-700 mb-6">
              By using Open Runs USA you agree to these terms.
            </p>

            {/* Minimum Age Requirement */}
            <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">Minimum Age Requirement</h2>
            <p className="text-zinc-700 mb-4">
              You must be at least 13 years old to use Open Runs USA. By creating an account, you represent and warrant that you are 13 years of age or older.
            </p>
            <p className="text-zinc-700 mb-6">
              If we become aware that an account has been created by a user under 13, we reserve the right to suspend or delete the account.
            </p>

            {/* Platform Purpose */}
            <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">Platform Purpose</h2>
            <p className="text-zinc-700 mb-6">
              Open Runs is designed to help players organize pickup basketball games.
            </p>

            {/* User Responsibilities */}
            <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">User Responsibilities</h2>
            <p className="text-zinc-700 mb-6">
              Users must provide accurate information and behave respectfully.
            </p>

            {/* Acceptable Use */}
            <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">Acceptable Use</h2>
            <p className="text-zinc-700 mb-4">Users may not:</p>
            <ul className="list-disc pl-6 text-zinc-700 space-y-2 mb-6">
              <li>Harass other players</li>
              <li>Post abusive content</li>
              <li>Create fake accounts</li>
              <li>Disrupt games intentionally</li>
            </ul>

            {/* Game Participation Disclaimer */}
            <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">Game Participation Disclaimer</h2>
            <p className="text-zinc-700 mb-4">
              Basketball involves inherent physical risks.
            </p>
            <p className="text-zinc-700 mb-4">
              Users participate in games organized through Open Runs at their own risk.
            </p>
            <p className="text-zinc-700 mb-6">
              Open Runs USA is not responsible for injuries or disputes that occur during games.
            </p>

            {/* Account Termination */}
            <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">Account Termination</h2>
            <p className="text-zinc-700 mb-6">
              Accounts that violate platform rules may be suspended.
            </p>

            {/* Contact */}
            <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">Contact</h2>
            <p className="text-zinc-700 mb-6">
              <a href="mailto:openrunshelp@gmail.com" className="text-orange-600 hover:text-orange-700 underline">
                openrunshelp@gmail.com
              </a>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
